module.exports = __webpack_public_path__ + "files/671bce94f8415e2ef057f64081a4cdc7.png";